import { BoxProps, Stack } from '@chakra-ui/react';
import { Card, Divider, IconButton, Text } from '@diamond/shared/ui';

export interface BuyerProfileCardProps extends BoxProps {
  children: React.ReactNode;
  icon: React.ReactElement;
  cardTitle: string;
}

export function BuyerProfileCard({
  children,
  icon,
  cardTitle,
  ...props
}: BuyerProfileCardProps) {
  return (
    <Card
      p="4"
      m={0}
      {...props}
      shadow="base"
      border="1px"
      borderColor="gray.33"
      rounded="lg"
    >
      <Stack direction="row" spacing="4" align="center" pb="4">
        <IconButton
          aria-label={cardTitle}
          name={cardTitle}
          icon={icon}
          variant="outline"
          borderWidth="1px"
          borderColor="blue"
          color="blue"
        />
        <Text fontWeight="semibold">{cardTitle}</Text>
      </Stack>
      <Divider />
      <Card p="4">{children}</Card>
    </Card>
  );
}

export default BuyerProfileCard;
